import { Button } from 'library/components/button';
import { FormattedMessage } from 'react-intl';

import { PinkBuilding } from '@src/components/atoms/icons/pink-building';
import { Grid } from '@src/components/atoms/layout/grid';
import { LinkTripAction } from '@src/components/molecules/link-trip-action';
import { useBrand } from '@src/contexts/brand-context';
import { useCmsContent } from '@src/contexts/cms-content-context';
import { useProfile } from '@src/features/profile/contexts/profile-context';
import { useLocale } from '@src/hooks/use-locale';

import { IllustrationWrapper, LinkTripExploreWrapper, LoggedInHeader, StartExploring } from './styles';

export const LinkTripOrStartExploring = () => {
  const content = useCmsContent();
  const { data } = useProfile();

  const locale = useLocale();
  const { brand } = useBrand();
  const websiteUrl = new URL(`/${locale}`, brand.websiteUrl ?? 'https://numastays.com');

  return (
    <LoggedInHeader>
      <Grid>
        <LinkTripExploreWrapper>
          <h1>
            <FormattedMessage
              id="noGuestUpcomingTrips"
              defaultMessage={content.noUpcomingTripsTitleSignedIn}
              values={{ name: data?.firstName }}
            />
          </h1>

          <StartExploring $isCentered $noMargin>
            {content.startExploringDescription}
          </StartExploring>

          <IllustrationWrapper>
            <PinkBuilding />
          </IllustrationWrapper>

          <Button variant="primary" size="large" href={websiteUrl.href}>
            {content.startExploringCta}
          </Button>

          <LinkTripAction />
        </LinkTripExploreWrapper>
      </Grid>
    </LoggedInHeader>
  );
};
